import { render, staticRenderFns } from "./licenceDetails.vue?vue&type=template&id=a665e750&scoped=true"
import script from "./licenceDetails.vue?vue&type=script&lang=js"
export * from "./licenceDetails.vue?vue&type=script&lang=js"
import style0 from "./licenceDetails.vue?vue&type=style&index=0&id=a665e750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a665e750",
  null
  
)

export default component.exports